/**
 * API 関連の定数 (v2)
 *
 * ローカル開発時: Emulator の URL を使用
 * 本番環境: Cloud Functions の直接 URL を使用
 *
 * 【統合 API 設計】
 * 全ての onRequest (Express) ハンドラーは1つの `api` Cloud Function に統合。
 * これによりコールドスタートが1回で済み、レスポンス速度が大幅に改善される。
 *
 * Before: /admins, /customers, /logs ... (個別関数 → 個別コールドスタート)
 * After:  /api/admins, /api/customers, /api/logs ... (1関数 → 1回のコールドスタート)
 */

// Cloud Functions のリージョン
const FUNCTIONS_REGION = "asia-northeast1";

// 本番用ベース URL（Cloud Functions v2 の直接 URL）
const PROD_FUNCTIONS_BASE = `https://${FUNCTIONS_REGION}-${import.meta.env.VITE_FIREBASE_PROJECT_ID}.cloudfunctions.net`;

// Emulator 用ベース URL
const DEV_FUNCTIONS_BASE = "http://localhost:5001/demo-project/asia-northeast1";

// 環境に応じたベース URL（統合 API パス付き）
const FUNCTIONS_BASE = import.meta.env.DEV ? DEV_FUNCTIONS_BASE : PROD_FUNCTIONS_BASE;

// 統合 API のベースパス
const API_PREFIX = `${FUNCTIONS_BASE}/api`;

export const API_BASE_URL = `${API_PREFIX}/logs`;

export const CUSTOMER_API_BASE_URL = `${API_PREFIX}/customers`;

export const PARTNER_API_BASE_URL = `${FUNCTIONS_BASE}/partners`;

export const ADMIN_API_BASE_URL = `${API_PREFIX}/admins`;

export const OPERATION_LOG_API_BASE_URL = `${API_PREFIX}/operationLogs`;

export const DASHBOARD_API_BASE_URL = `${API_PREFIX}/dashboard`;

export const ASSISTANT_API_BASE_URL = `${API_PREFIX}/assistant`;

export const USAGE_STATS_API_BASE_URL = `${API_PREFIX}/usageStats`;
